module.exports = __webpack_public_path__ + "img/LT112043996.f56721ac.png";